import { useEffect } from "react";

type SeoProps = {
  title: string;
  description?: string;
  keywords?: string;
};

function upsertMeta(name: string, content?: string) {
  if (!content) return;
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, keywords }: SeoProps) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("description", description);
    upsertMeta("keywords", keywords);
  }, [title, description, keywords]);

  return null;
}